import React from 'react';
import hexToRgbChannels from '../../assets/js/hexToRgbChannels';
import '../../assets/styles/IconTile.css';

const IconTile = ({ icon, accent = '#7C3AED', caption, className = '', ...props }) => (
  <figure
    className={`tp-icon-tile ${className}`.trim()}
    style={{ '--tile-rgb': hexToRgbChannels(accent) || undefined }}
    {...props}
  >
    <span className="tp-icon-tile__rings" aria-hidden="true" />
    <span className="tp-icon-tile__icon" aria-hidden="true">{icon}</span>
    {caption && (
      <figcaption className="tp-icon-tile__caption">
        <span className="tp-icon-tile__dot" aria-hidden="true" />
        {caption}
      </figcaption>
    )}
  </figure>
);

export default IconTile;
export { IconTile };
